<template>

    <div class="w-full">

        <navbar :network="station"></navbar>

        <div class="flex flex-wrap flex-1 mt-5 px-5">

            <div class="w-full md:w-1/3 px-5 my-5" v-for="chaser in chasers">
            
                <div class="w-full bg-white">
                    <div class="w-full relative px-5 bg-black py-2 text-white flex flex-row">
                        <div>
                            <div class="rounded bg-red-dark uppercase px-2 py-1 text-sm font-bold mr-3" v-if="chaser.stream_status == true">LIVE</div>
                        </div>
                        <div>
                            <h2>{{chaser.name}}</h2>
                        </div>
                        <span class="absolute pin-r pin-t mt-2 mr-3 rounded bg-blue-dark uppercase px-2 py-1 text-sm font-bold mr-3" v-if="chaser.location !== null">{{ chaser.location }}</span>
                        <span class="absolute pin-r pin-t mt-2 mr-3 rounded bg-grey-dark uppercase px-2 py-1 text-sm font-bold mr-3" v-if="chaser.location == null">Location unavailable</span>
                    </div>
                    <div>
                        <div class="embed-responsive embed-responsive-16by9">
                            <StreamPlayer :streamId="chaser.stream_id" :ads="false" :watermark="false" class="embed-responsive-item" />
                        </div>
                        <div class="w-full">
                            <StreamUrl :streamId="chaser.stream_id" />
                        </div>
                    </div>
                </div>

            </div>

        </div>

    </div>
</template>

<script>

    import { EventBus } from '@/events'
    import * as Config from '@/config'

    import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
    import Navbar from '@/components/Navbar'

    import StreamPlayer from '@/components/Modules/StreamPlayer'
    import StreamUrl from '@/components/Modules/StreamUrl'

    export default {
        name: 'Wall',
        data() {
            return {
                chasers: [],
            }
        },
        beforeMount() {
            if(window.location.hostname == 'localhost') {
                this.station = 'kake'
                return
            }
            this.station = window.location.hostname.split('.')[0]
        },
        mounted() {
            this.getChasers();

            var _this = this;
            setInterval(function() {
                _this.getChasers();
            }, 15000);
        },
        components: {
            StreamPlayer,
            Navbar,
            StreamUrl
        },
        methods: {
            getChasers() {
                this.$http.get(Config.apiPath + "/api/v1/networks/" + this.station + "/chasers").then((response) => {
                    this.$set(this, 'chasers', response.data);
                })
            }
        },
    }

</script>

<style>
    .embed-responsive {
        position: relative;
        display: block;
        height: 0;
        padding: 0;
        overflow: hidden;
    }

    .embed-responsive.embed-responsive-16by9 {
        padding-bottom: 56.25%;
    }

    .embed-responsive .embed-responsive-item, .embed-responsive embed, .embed-responsive iframe, .embed-responsive object {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 0;
    }

</style>
